import { addSavedSearchByColumn, deleteSavedSearch, getSavedSearchByColumnByName, updateSavedSearchByColumn } from '../../actions/savedSearches/SavedSearchesActions';
import { confirm } from 'devextreme/ui/dialog';
import { useState } from 'react';
import { ShareFilter } from './ShareFilter';
import { FilterNavigationHeader } from './FilterNavigationHeader';
import { FilterPreviewHeader } from './FilterPreviewHeader';
import { FilterNameControls } from './FilterNameControls';
import { FilterRulesList } from './FilterRulesList';

export const ColumnsFilterReview = (props) => {
    const { 
        filterRows, 
        filterName, 
        setFilterName, 
        selectedSearch,
        onNext,
        onBack,
        onApply,
        currentStep = 3,
        totalSteps = 3,
        stepTitle = "Review & Apply Filter"
    } = props;
    const [showShareTemplate, setShowShareTemplate] = useState(false);


    const sharedSearch = selectedSearch?.shared;
    const searchId = selectedSearch?.id;

    console.log(selectedSearch);

    const logicalOperatorOptions = [
        {
            id: 1, text: 'Or'
        },
        {
            id: 2, text: 'And'
        },
    ];

    const getLogicalOperatorText = (id) => {
        return logicalOperatorOptions?.find(
            a => a.id === id
        )?.text;
    }
    const saveTemplate = async () => {
        var existingSearch = await getSavedSearchByColumnByName(filterName);
        if (existingSearch !== "") {
            let result = confirm("<i>The filter already exists do you want to overwrite it?</i>", "Confirm updating existing filter");
            result.then(async (dialogResult) => {
                if (dialogResult) {
                    await updateSavedSearchByColumn(filterName, filterRows);
                    alert("Filter Updated Successfully");
                }
            });
        }
        else {
            await addSavedSearchByColumn(filterName, filterRows);
            alert("Filter added Successfully");
        }
    }

    const shareTemplate = () => {
        setShowShareTemplate(true);
    }

    const DeleteTemplate = async () => {
        let result = confirm("<i>Are you sure you want to delete the filter?</i>", "Confirm deleting filter");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                await deleteSavedSearch(searchId);
                alert("Filter Deleted Successfully");
            }
        });
    }

    console.log(filterRows);
    
    const getActiveFiltersCount = () => {
        return filterRows?.filter(row => row.column && row.operator).length || 0;
    };

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "hidden",
            backgroundColor: "#f8f9fa",
            padding: "0.5rem",
            boxSizing: "border-box"
        }}>
            {/* Navigation Header */}
            <FilterNavigationHeader
                stepTitle={stepTitle}
                currentStep={currentStep}
                totalSteps={totalSteps}
                activeFiltersCount={getActiveFiltersCount()}
                onBack={onBack}
                onApply={onApply}
                filterName={filterName}
                showApply={true}
            />

            {/* Header Section */}
            <FilterPreviewHeader />

            {/* Sticky Filter Name Section */}
            <FilterNameControls
                filterName={filterName}
                setFilterName={setFilterName}
                onSave={saveTemplate}
                onShare={shareTemplate}
                onDelete={DeleteTemplate}
                showShareAndDelete={sharedSearch === false}
            />

            {/* Scrollable Filter Rules */}
            <FilterRulesList
                filterRows={filterRows}
                getLogicalOperatorText={getLogicalOperatorText}
                getActiveFiltersCount={getActiveFiltersCount}
            />

            {showShareTemplate && (
                <ShareFilter 
                    visible={showShareTemplate} 
                    searchId={searchId} 
                    onClose={() => setShowShareTemplate(false)} 
                />
            )}
        </div>
    );
}
